import styled from "styled-components"

const PrevButtonStyled = styled.button`
  background-color: ${(props) =>
    props.theme.b_color_gradients.b_dark} !important;
`

const NextButtonStyled = styled.button`
  background-color: ${(props) =>
    props.theme.b_color_gradients.b_dark} !important;
`

const CarouselOpenerButton = styled.button`
  background-color: ${(props) =>
    props.theme.b_color_gradients.b_dark} !important;
`

export { PrevButtonStyled, NextButtonStyled, CarouselOpenerButton }
